import { Team__LaChona } from "../teams/LaChona";
import { Team__Coyotes } from "../teams/Coyotes";
import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros } from "../teams/Cerveceros";

const LaChona = {
  team: Team__LaChona,
  playingPlayers: [],

  goals: 29,
  penaltyGoals: 0,
  isWinner: false,
};

const Coyotes = {
  team: Team__Coyotes,
  playingPlayers: [],

  goals: 69,
  penaltyGoals: 0,
  isWinner: false,
};

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 53,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 67,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada3 = {
  jornadaPosition: 3,
  matches: [
    {
      team1: LaChona,
      team2: Coyotes,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Aliados,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Miércoles",
      date: "2026-07-29",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
